// src/contexts/Context/slices/useSectorSlice.js
import { useMemo } from "react";
import { useBuildingSlice } from "./Sector/useBuildingSlice";
import { useProductSlice } from "./Sector/useProductSlice";
import { useProjectSlice } from "./Sector/useProjectSlice";

export const useSectorSlice = () => {
  const productContext = useProductSlice();
  const projectContext = useProjectSlice();
  const buildingContext = useBuildingSlice();

  return useMemo(() => ({ ...productContext, ...projectContext, ...buildingContext }), [productContext, projectContext, buildingContext]);
};
